module.exports = __webpack_public_path__ + "static/media/downloadExcel.a14b5e9f.png";